/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Blog meta reducer
 */

import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  CANCEL_FETCHING_BLOG_POSTS,
  CLEAR_BLOG_POSTS,
  DONE_FETCHING_BLOG_POSTS,
  ERROR_FETCHING_BLOG_POSTS,
  RECEIVE_BLOG_POSTS,
  START_FETCHING_BLOG_POSTS,
} from '../constants/index'

const metaReducer = combineReducers({
  error: handleActions(
    {
      [ERROR_FETCHING_BLOG_POSTS]: (_, action) => action.payload,
      [combineActions(START_FETCHING_BLOG_POSTS, CLEAR_BLOG_POSTS)]: () => null,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_BLOG_POSTS]: () => true,
      [DONE_FETCHING_BLOG_POSTS]: () => false,
    },
    false
  ),
  fetchedAt: handleActions(
    {
      [RECEIVE_BLOG_POSTS]: () => Date.now(),
      [CLEAR_BLOG_POSTS]: () => null,
    },
    null
  ),
  canceled: handleActions(
    {
      [CANCEL_FETCHING_BLOG_POSTS]: () => true,
      [combineActions(CLEAR_BLOG_POSTS, DONE_FETCHING_BLOG_POSTS, START_FETCHING_BLOG_POSTS)]: () =>
        false,
    },
    false
  ),
})

export default metaReducer
